import {Component, OnInit} from '@angular/core';
import {MenuItemComponent} from '../menu-item/menu-item.component';

@Component({
    selector: 'app-side-nav',
    templateUrl: './side-nav.component.html',
    styleUrls: ['./side-nav.component.css'],
    imports: [
        MenuItemComponent
    ]
})
export class SideNavComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
